module.exports = __webpack_public_path__ + "static/media/vexpo-logo.eba2c2e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/vexpo-logo.svg
// module id = 745
// module chunks = 0